import { VisualSuper } from "./visual-super.component.js";

class Media extends VisualSuper {
  namespace = "visual:media";
}

const media = new Media();
export { Media, media };
